import React, { useEffect, useState, useContext } from "react";
import {
  Grid,
  Box,
  Button, Radio, RadioGroup, FormControl, FormControlLabel, Paper
} from "@material-ui/core";
import clsx from "clsx";
import useStyles from "../../../src/themes/makeStyles";
import PageTitle from "./PageTitle";
import { Typography } from "./Wrappers";
import PropTypes from 'prop-types';
import {
  get_dashboad_data, get_inventory_inbound_data, get_pending_grn_data, out_bound_dashboard_response,
  get_age_wise_stock_report, grn_complaince_dashboard_response, vivo_complaince_dashboard_response, mr_complaince_dashboard_response,
  get_all_customers, get_age_wise_stock_quantity, download_age_stock_qua_data_dashboard,
  download_pending_grn_data_dashboard, download_pending_outbound_data_dashboard
} from "../../common";
import DashboardCard from "./DashboardCard";
import InventoryStatus from "./DashboardTables/InventoryStatus";
import InventoryDetailTable from "./DashboardTables/InventoryDetailTable";
import InventoryGrnStatusDetailTable from './DashboardTables/InventoryGrnStatusDetailTable';
import ExpectedInventoryDetailTable from "./DashboardTables/ExpectedInventoryDetailTable";
// import InboundConsignmentStatus from "./DashboardTables/InbondConStatus";
import LineChart from "./DashboardCharts/LineChart";
import PendingStatus from "./DashboardCharts/BarChart";
import OutbondStatus from "./DashboardCharts/BarChartWithoutCustomTooltip";
// import RoundLoader from '../../components/RoundLoader';
import AutocompleteController from "../../components/AutoCompleteController";
import { useForm } from "react-hook-form";
import SkeletonLoader from "./SkeletonLoader";
import MasterdataContext from "../../common/contexts/MasterdataContext";
import { useHistory } from "react-router-dom";
import ActionTypes from "../../common/constants/ActionTypes";
import { list_warehouse_master_by_email, get_warehouse_code_by_name, authentication_email } from "../../common";

import OkDamageCompletedInventory from "./DashboardTables/OkDamageCompletedInventory";
import OkDamagePendingInventory from "./DashboardTables/OkDamagePendingInventory";
import jwt from 'json-web-token'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function Dashboard() {
  var classes = useStyles();
  const { masterdata } = useContext(MasterdataContext);

  const [ConsignmentReport, setConsignmentReport] = useState("Reports of Consignment")
  const [dashboardData, setDashboardData] = useState([])
  const [currentInventoryTable, setCurrentInventoryTable] = useState(false);
  const [GrnStatusDetailIventoryTable, setGrnStatusDetailInventoryTable] = useState(false);
  const [expectedInventoryTable, setExpectedInventoryTable] = useState(false)
  const [roundLoader, setRoundLoader] = useState(false)
  const [customerList, setCustomerList] = useState(masterdata.CustomerDetails ? masterdata.CustomerDetails : []);
  // const [customerList, setCustomerList] = useState([]);
  const [FinancialYears, setFinancialYears] = useState([]);
  const [currentInventoryInbound, setCurrentInventoryInbound] = useState([]);
  const [resetvalues, SetResetvalues] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [inventoryDetailData, setInventoryDetailData] = useState([]);
  const [expectedInventoryDetailData, setExpectedInventoryDetailData] = useState([]);
  const [inventoryGrnDetailData, setInventoryGrnDetailDetailData] = useState([]);
  const [sapPendingChartData, setSapPendingChartData] = useState([]);
  const [outBoundDashboardResponse, setOutBoundDashboardResponse] = useState([]);
  const [ageWiseResponse, setAgeWiseResponse] = useState([]);
  const [ageWiseQuantityResponse, setAgeWiseQuantityResponse] = useState([]);
  const [ageWiseResponseLoading, setAgeWiseResponseLoading] = useState(false);
  const [ageWiseQuantityResponseLoading, setAgeWiseQuantityResponseLoading] = useState(false);
  const [grnComplainceDashboardResponse, setGrnComplainceDashboardResponse] = useState([]);
  const [vivoComplainceDashboardResponse, setVivoComplainceDashboardResponse] = useState([]);
  const [mrnComplainceDashboardResponse, setMrComplainceDashboardResponse] = useState([]);
  const [financialYrMonthsVivo, setMonthsOfFinancialYrVivo] = useState();
  const [financialYrMonthsGrn, setMonthsOfFinancialYrGrn] = useState();
  const [financialYrMonthsMr, setMonthsOfFinancialYrMr] = useState();
  const history = useHistory();
  const [warehouseDataDropdown, setWarehouseDataDropdown] = React.useState([]);
  const [CurrInventCompletedOkDamage, setCurrInventCompletedOkDamage] = React.useState(false);
  const [CurInventCompletedOkDamageData, setCurInventCompletedOkDamageData] = React.useState([]);
  const [CurrInventPendingOkDamage, setCurrInventPendingOkDamage] = React.useState(false);
  const [CurInventPendingOkDamageData, setCurInventPendingOkDamageData] = React.useState([]);
  const [PendingGrnDate, setPendingGrnDate] = React.useState('');
  const [PendingOutboundDate, setPendingOutboundDate] = React.useState('');
  const [DownloadButton, setDownloadButton] = React.useState(false);
  const [stockQuantityAge, setStockQuantityAge] = React.useState('');
  const [messageProcessed, setMessageProcessed] = useState(false);

  const [warehouseData, setWarehouseData] = React.useState((window.top !== window.self) ?
    JSON.parse('{"warehouse_code":"WHJH003","warehouse_name":"IM Section- Jamshedpur"}') : (JSON.parse(sessionStorage.getItem("warehouseData")) || {}));

  const wareHouseNamesList = {
    options: warehouseDataDropdown,
  };


  let defaultValues = {
    customer_name: null,
    financial_year: null
  };

  const {
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
  } = useForm({ defaultValues });

  const CustomerNames = {
    options: customerList,
    getOptionLabel: (option) => option.customer_name,
  };

  const financialYrs = {
    options: FinancialYears ? FinancialYears : [],
    getOptionLabel: (option) => option.value,
  };

  useEffect(() => {
    if (window.top !== window.self) {
      let damageObj = { "warehouse_code": "WHJH003", "warehouse_name": "IM Section- Jamshedpur" }
      sessionStorage.setItem("warehouseData", JSON.stringify(damageObj));
    }

    window.addEventListener('message', handleReceiveMessageFromParent);
    const responseMessage = 'Hello from the iframe!';
    // window.parent.postMessage(responseMessage, window.origin);

    getCustomerMaster();

    if (window.top === window.self) {
      let finYrs;

      function getCurrentFinancialYear() {
        const thisYear = (new Date()).getFullYear();

        const thisMonth = (new Date()).getMonth() + 1;
        let yearArray;

        if (thisMonth > 3) {
          yearArray = [-1, 0, 1, 2, 3, 4, 5].map((count) => ({ value: `${thisYear - count - 1}-${thisYear - count}` }));
        } else {
          yearArray = [0, 1, 2, 3, 4, 5].map((count) => ({ value: `${thisYear - count - 1}-${thisYear - count}` }));
        }

        finYrs = yearArray;
        setValue('financial_year', yearArray[0])
        setFinancialYears(yearArray)
      }
      getCurrentFinancialYear();
      getDashboardInboundOutboundData(finYrs, 0);
      getPendingGRNData();
      complainceReportsData(finYrs);
      getInventoryDashboardData(finYrs);

    }

    return () => {
      // Clean up the event listener
      window.addEventListener('message', handleReceiveMessageFromParent, { once: true });
    };
  }, []);


  const handleReceiveMessageFromParent = (event) => {
    if (messageProcessed) return;  // ⛔ Prevent multiple processing

    const receivedMessage = event.data;

    if (receivedMessage.token && receivedMessage.user_email) {
      setMessageProcessed(true);
      handleMessage(receivedMessage);
    }
  };

  const handleMessage = async (e) => {
    sessionStorage.setItem('token', e.token);
    sessionStorage.setItem('user_email', e.user_email);
    let finYrs;

    function getCurrentFinancialYear() {
      const thisYear = (new Date()).getFullYear();
      const thisMonth = (new Date()).getMonth() + 1;
      let yearArray;

      if (thisMonth > 3) {
        yearArray = [-1, 0, 1, 2, 3, 4, 5].map((count) => ({ value: `${thisYear - count - 1}-${thisYear - count}` }));
      } else {
        yearArray = [0, 1, 2, 3, 4, 5].map((count) => ({ value: `${thisYear - count - 1}-${thisYear - count}` }));
      }

      finYrs = yearArray;
      setValue('financial_year', yearArray[0])
      setFinancialYears(yearArray)
    }

    let postobj = { email: e.user_email };

    jwt.encode('WAREHOUSE', postobj, function (err2, userEmail) {

      authentication_email(userEmail).then(res => {
        sessionStorage.setItem('token', res.token)

        if (res.issuccess === 1) {
          list_warehouse_master_by_email(postobj, res.token).then((data) => {
            if (data.Records[0] == null) {
            } else {
              // setWarehouseData(data.Records[0][0].warehouselist.split(","));
              sessionStorage.setItem("user_type", data.Records[0][0].user_type)
            }
          });
        }

        getWarehouseNamesList();
        getCurrentFinancialYear();
        getDashboardInboundOutboundData(finYrs, 0);
        getPendingGRNData();
        complainceReportsData(finYrs);
        getInventoryDashboardData(finYrs);
      })
    })
  }

  const getCustomerMaster = async () => {
    let queryParam = {
      warehouse_code: warehouseData.warehouse_code
    }
    const customerResp = await get_all_customers(queryParam);

    if (customerResp && customerResp.Records) {
      setCustomerList(customerResp.Records)
    }
  }

  const [warehouseNamesList, setWarehouseNamesList] = React.useState([]);

  const cardParameters = {
    param1: "YTD",
    param2: "MTD",
    param3: "Today"
  }

  // Inbound - Job Data 0
  const inBoundJobsReceived = {
    YTD: (dashboardData[0] && dashboardData[0].ytd_jobs_received) ? dashboardData[0].ytd_jobs_received : 0,
    MTD: (dashboardData[0] && dashboardData[0].mtd_jobs_received) ? dashboardData[0].mtd_jobs_received : 0,
    Today: (dashboardData[0] && dashboardData[0].dtd_jobs_received) ? dashboardData[0].dtd_jobs_received : 0
  }

  const inBoundJobsInProgess = {
    YTD: (dashboardData[1] && dashboardData[1].ytd_jobs_inprogress) ? dashboardData[1].ytd_jobs_inprogress : 0,
    MTD: (dashboardData[1] && dashboardData[1].mtd_jobs_inprogress) ? dashboardData[1].mtd_jobs_inprogress : 0,
    Today: (dashboardData[1] && dashboardData[1].dtd_jobs_inprogress) ? dashboardData[1].dtd_jobs_inprogress : 0
  }

  const inBoundJobsCompleted = {
    YTD: (dashboardData[2] && dashboardData[2].ytd_jobs_completed) ? dashboardData[2].ytd_jobs_completed : 0,
    MTD: (dashboardData[2] && dashboardData[2].mtd_jobs_completed) ? dashboardData[2].mtd_jobs_completed : 0,
    Today: (dashboardData[2] && dashboardData[2].dtd_jobs_completed) ? dashboardData[2].dtd_jobs_completed : 0
  }

  const inBoundSapGrnPending = {
    YTD: (dashboardData[3] && dashboardData[3].ytd_sap_grn_pending) ? dashboardData[3].ytd_sap_grn_pending : 0,
    MTD: (dashboardData[3] && dashboardData[3].mtd_sap_grn_pending) ? dashboardData[3].mtd_sap_grn_pending : 0,
    Today: (dashboardData[3] && dashboardData[3].dtd_sap_grn_pending) ? dashboardData[3].dtd_sap_grn_pending : 0
  }

  // Inbound - Vehicle Data 1
  const inboundVehicleReported = {
    YTD: (dashboardData[0] && dashboardData[0].primary_grn_reported) ? dashboardData[0].primary_grn_reported : 0,
    MTD: (dashboardData[0] && dashboardData[0].mtd_primary_grn_reported) ? dashboardData[0].mtd_primary_grn_reported : 0,
    Today: (dashboardData[0] && dashboardData[0].dtd_primary_grn_reported) ? dashboardData[0].dtd_primary_grn_reported : 0
  }

  const inboundUnloadInProgress = {
    YTD: (dashboardData[1] && dashboardData[1].ytd_total_unloading_in_progress) ? dashboardData[1].ytd_total_unloading_in_progress : 0,
    MTD: (dashboardData[1] && dashboardData[1].mtd_total_unloading_in_progress) ? dashboardData[1].mtd_total_unloading_in_progress : 0,
    Today: (dashboardData[1] && dashboardData[1].dtd_total_unloading_in_progress) ? dashboardData[1].dtd_total_unloading_in_progress : 0
  }

  const inboundReleaseFromGate = {
    YTD: (dashboardData[2] && dashboardData[2].ytd_release_time_from_gate) ? dashboardData[2].ytd_release_time_from_gate : 0,
    MTD: (dashboardData[2] && dashboardData[2].mtd_release_time_from_gate) ? dashboardData[2].mtd_release_time_from_gate : 0,
    Today: (dashboardData[2] && dashboardData[2].dtd_release_time_from_gate) ? dashboardData[2].dtd_release_time_from_gate : 0
  }

  const inboundVehiclesDiverted = {
    YTD: (dashboardData[3] && dashboardData[3].ytd_total_diverted) ? dashboardData[3].ytd_total_diverted : 0,
    MTD: (dashboardData[3] && dashboardData[3].mtd_total_diverted) ? dashboardData[3].mtd_total_diverted : 0,
    Today: (dashboardData[3] && dashboardData[3].dtd_total_diverted) ? dashboardData[3].dtd_total_diverted : 0
  }

  // Inbound - UMC Data 2
  const inBoundUMCsReceived = {
    YTD: (dashboardData[0] && dashboardData[0].ytd_umc_jobs_received) ? dashboardData[0].ytd_umc_jobs_received : 0,
    MTD: (dashboardData[0] && dashboardData[0].mtd_umc_jobs_received) ? dashboardData[0].mtd_umc_jobs_received : 0,
    Today: (dashboardData[0] && dashboardData[0].dtd_umc_jobs_received) ? dashboardData[0].dtd_umc_jobs_received : 0
  }

  const inBoundUMCsInProgess = {
    YTD: (dashboardData[1] && dashboardData[1].ytd_umc_jobs_inprogress) ? dashboardData[1].ytd_umc_jobs_inprogress : 0,
    MTD: (dashboardData[1] && dashboardData[1].mtd_umc_jobs_inprogress) ? dashboardData[1].mtd_umc_jobs_inprogress : 0,
    Today: (dashboardData[1] && dashboardData[1].dtd_umc_jobs_inprogress) ? dashboardData[1].dtd_umc_jobs_inprogress : 0
  }

  const inBoundUMCsCompleted = {
    YTD: (dashboardData[2] && dashboardData[2].ytd_umc_jobs_completed) ? dashboardData[2].ytd_umc_jobs_completed : 0,
    MTD: (dashboardData[2] && dashboardData[2].mtd_umc_jobs_completed) ? dashboardData[2].mtd_umc_jobs_completed : 0,
    Today: (dashboardData[2] && dashboardData[2].dtd_umc_jobs_completed) ? dashboardData[2].dtd_umc_jobs_completed : 0
  }

  const inBoundUMCsSapGrnPending = {
    YTD: (dashboardData[3] && dashboardData[3].ytd_umc_sap_grn_pending) ? dashboardData[3].ytd_umc_sap_grn_pending : 0,
    MTD: (dashboardData[3] && dashboardData[3].mtd_umc_sap_grn_pending) ? dashboardData[3].mtd_umc_sap_grn_pending : 0,
    Today: (dashboardData[3] && dashboardData[3].dtd_umc_sap_grn_pending) ? dashboardData[3].dtd_umc_sap_grn_pending : 0
  }

  // Outbound - UMC Data 3
  const outBoundIndentReceived = {
    YTD: (dashboardData[0] && dashboardData[0].ytd_indent_received) ? dashboardData[0].ytd_indent_received : 0,
    MTD: (dashboardData[0] && dashboardData[0].mtd_indent_received) ? dashboardData[0].mtd_indent_received : 0,
    Today: (dashboardData[0] && dashboardData[0].dtd_indent_received) ? dashboardData[0].dtd_indent_received : 0
  }

  const outBoundIndentInProgress = {
    YTD: (dashboardData[1] && dashboardData[1].ytd_indent_inprogress) ? dashboardData[1].ytd_indent_inprogress : 0,
    MTD: (dashboardData[1] && dashboardData[1].mtd_indent_inprogress) ? dashboardData[1].mtd_indent_inprogress : 0,
    Today: (dashboardData[1] && dashboardData[1].dtd_indent_inprogress) ? dashboardData[1].dtd_indent_inprogress : 0
  }

  const outBoundIndentCompleted = {
    YTD: (dashboardData[2] && dashboardData[2].ytd_indent_completed) ? dashboardData[2].ytd_indent_completed : 0,
    MTD: (dashboardData[2] && dashboardData[2].mtd_indent_completed) ? dashboardData[2].mtd_indent_completed : 0,
    Today: (dashboardData[2] && dashboardData[2].dtd_indent_completed) ? dashboardData[2].dtd_indent_completed : 0
  }

  const outBoundPODSubmitted = {
    YTD: (dashboardData[3] && dashboardData[3].ytd_pod_completed) ? dashboardData[3].ytd_pod_completed : 0,
    MTD: (dashboardData[3] && dashboardData[3].mtd_pod_completed) ? dashboardData[3].mtd_pod_completed : 0,
    Today: (dashboardData[3] && dashboardData[3].dtd_pod_completed) ? dashboardData[3].dtd_pod_completed : 0
  }

  // Outbound - Vehicle Data 4
  const outboundVehiclesReported = {
    YTD: (dashboardData[0] && dashboardData[0].ytd_outbound_indent_recived_reported) ? dashboardData[0].ytd_outbound_indent_recived_reported : 0,
    MTD: (dashboardData[0] && dashboardData[0].mtd_outbound_indent_recived_reported) ? dashboardData[0].mtd_outbound_indent_recived_reported : 0,
    Today: (dashboardData[0] && dashboardData[0].dtd_outbound_indent_recived_reported) ? dashboardData[0].dtd_outbound_indent_recived_reported : 0
  }

  const outBoundVehiclesLoadingInProgress = {
    YTD: (dashboardData[1] && dashboardData[1].ytd_outbound_in_progress_reported) ? dashboardData[1].ytd_outbound_in_progress_reported : 0,
    MTD: (dashboardData[1] && dashboardData[1].mtd_outbound_in_progress_reported) ? dashboardData[1].mtd_outbound_in_progress_reported : 0,
    Today: (dashboardData[1] && dashboardData[1].dtd_outbound_in_progress_reported) ? dashboardData[1].dtd_outbound_in_progress_reported : 0
  }

  const outBoundVehiclesGoodsIssuedParams = {
    YTD: (dashboardData[2] && dashboardData[2].ytd_outbound_goods_issued) ? dashboardData[2].ytd_outbound_goods_issued : 0,
    MTD: (dashboardData[2] && dashboardData[2].mtd_outbound_goods_issued) ? dashboardData[2].mtd_outbound_goods_issued : 0,
    Today: (dashboardData[2] && dashboardData[2].dtd_outbound_goods_issued) ? dashboardData[2].dtd_outbound_goods_issued : 0
  }

  // Outbound - UMC Data 5
  const outBoundUMCIndentReceived = {
    YTD: (dashboardData[0] && dashboardData[0].ytd_umc_indent_received) ? dashboardData[0].ytd_umc_indent_received : 0,
    MTD: (dashboardData[0] && dashboardData[0].mtd_umc_indent_received) ? dashboardData[0].mtd_umc_indent_received : 0,
    Today: (dashboardData[0] && dashboardData[0].dtd_umc_indent_received) ? dashboardData[0].dtd_umc_indent_received : 0
  }

  const outBoundUMCIndentInProgress = {
    YTD: (dashboardData[1] && dashboardData[1].ytd_umc_indent_inprogress) ? dashboardData[1].ytd_umc_indent_inprogress : 0,
    MTD: (dashboardData[1] && dashboardData[1].mtd_umc_indent_inprogress) ? dashboardData[1].mtd_umc_indent_inprogress : 0,
    Today: (dashboardData[1] && dashboardData[1].dtd_umc_indent_inprogress) ? dashboardData[1].dtd_umc_indent_inprogress : 0
  }

  const outBoundUMCIndentCompleted = {
    YTD: (dashboardData[2] && dashboardData[2].ytd_umc_indent_completed) ? dashboardData[2].ytd_umc_indent_completed : 0,
    MTD: (dashboardData[2] && dashboardData[2].mtd_umc_indent_completed) ? dashboardData[2].mtd_umc_indent_completed : 0,
    Today: (dashboardData[2] && dashboardData[2].dtd_umc_indent_completed) ? dashboardData[2].dtd_umc_indent_completed : 0
  }

  const outBoundUMCPodSubmitted = {
    YTD: (dashboardData[3] && dashboardData[3].ytd_umc_pod_completed) ? dashboardData[3].ytd_umc_pod_completed : 0,
    MTD: (dashboardData[3] && dashboardData[3].mtd_umc_pod_completed) ? dashboardData[3].mtd_umc_pod_completed : 0,
    Today: (dashboardData[3] && dashboardData[3].ytd_umc_pod_completed) ? dashboardData[3].ytd_umc_pod_completed : 0
  }

  const ageWiseCategories_X = ['< 1 month', '< 3 month', '< 6 month', '< 1 year', '< 2 year', '< 3 year', '< 5 year', '> 5 year']
  const pendingGRNCategories_X = ['24 Hr', '2 Days', '7 Days', '15 Days', '1 Month', '>1 Month']
  const outbondCategories_X = ['same Day', '2 Days', '7 Days', '15 Days', '1 Month', '>1 Month']
  // const GRNComplianceCategories_X = ["Apr'22", "May'22", "Jun'22", "Jul'22", "Aug'22", "Sep'22", "Oct'22", "Nov'22", "Dec'22", "Jan'23", "Feb'23", "Mar'23"]

  const handleInboundValue = (e) => {
    setConsignmentReport(e.target.value)

    let tabIndex = 0;

    if (e.target.value == "Reports of Consignment") {
      tabIndex = 0
    } else if (e.target.value == "Vehicle (Inbound)") {
      tabIndex = 1
    } else if (e.target.value == "Receiving UMC") {
      tabIndex = 2
    } else if (e.target.value == "Reports of Indent") {
      tabIndex = 3
    } else if (e.target.value == "Vehicles (Outbound)") {
      tabIndex = 4
    } else if (e.target.value == "Issued UMC") {
      tabIndex = 5
    }
    getDashboardInboundOutboundData(FinancialYears, tabIndex)
  }

  const getPendingGRNData = async (type, wdata) => {
    setSapPendingChartData([]);
    setAgeWiseResponse([]);
    setOutBoundDashboardResponse([]);
    setAgeWiseQuantityResponse([]);

    let queryparams = {
      warehouse_code: type === 'fromIframe' ? wdata.warehouse_code : warehouseData.warehouse_code,
      customer_name: getValues('customer_name') ? getValues('customer_name').customer_name : null,
    };

    AgeWiseStockReportResponse(queryparams);
    PendingGrnData(queryparams);
    OutboundDashboardResponse(queryparams);
    AgeWiseStockQuantityResponse(queryparams);
  }

  const PendingGrnData = async (params) => {
    const pendingGRNResponse = await get_pending_grn_data(params);

    if (pendingGRNResponse && pendingGRNResponse.Records && pendingGRNResponse.Records[0]) {
      setSapPendingChartData(pendingGRNResponse.Records[0])
    }
  }

  const OutboundDashboardResponse = async (params) => {
    const outbounddashboardResponse = await out_bound_dashboard_response(params);

    if (outbounddashboardResponse && outbounddashboardResponse.Records && outbounddashboardResponse.Records[0]) {
      setOutBoundDashboardResponse(outbounddashboardResponse.Records[0])
    }
  }

  const AgeWiseStockReportResponse = async (params) => {
    setAgeWiseResponseLoading(true);
    const ageStockReportResponse = await get_age_wise_stock_report(params);
    if (ageStockReportResponse && ageStockReportResponse.Records) {
      setAgeWiseResponse(ageStockReportResponse.Records[0]);
      setAgeWiseResponseLoading(false);
    }
  }

  const AgeWiseStockQuantityResponse = async (params) => {
    setAgeWiseQuantityResponseLoading(true);
    const ageStockQuantityResponse = await get_age_wise_stock_quantity(params);
    if (ageStockQuantityResponse && ageStockQuantityResponse.Records) {
      setAgeWiseQuantityResponse(ageStockQuantityResponse.Records[0]);
      setAgeWiseQuantityResponseLoading(false);
    }
  }

  const ClickToDownloadPendingGrnGraphData = async () => {
    setDownloadButton(true);
    let queryparams = {
      warehouse_code: warehouseData.warehouse_code,
      customer_name: getValues('customer_name') ? getValues('customer_name').customer_name : null
    };

    if (PendingGrnDate == '24 Hr') {
      queryparams.pending_grn_from_date = '0.8'
    } else if (PendingGrnDate == '2 Days') {
      queryparams.pending_grn_from_date = '1.8'
    } else if (PendingGrnDate == '7 Days') {
      queryparams.pending_grn_from_date = '5'
    } else if (PendingGrnDate == '15 Days') {
      queryparams.pending_grn_from_date = '10'
    } else if (PendingGrnDate == '1 Month') {
      queryparams.pending_grn_from_date = '25'
    } else if (PendingGrnDate == '>1 Month') {
      queryparams.pending_grn_from_date = '32'
    }

    if (PendingGrnDate) {
      await download_pending_grn_data_dashboard(queryparams);
      setDownloadButton(false)
    } else {
      window.alert('Please select Pending GRN From')
      setDownloadButton(false)
    }
  }

  const ClickToDownloadStockQuantityAgeGraphData = async () => {
    // setDownloadButton(true);
    let queryparams = {
      warehouse_code: warehouseData.warehouse_code,
      customer_name: getValues('customer_name') ? getValues('customer_name').customer_name : null
    };

    if (stockQuantityAge == '<1 Month') {
      queryparams.age = 1
    } else if (stockQuantityAge == '<3 Months') {
      queryparams.age = 2
    } else if (stockQuantityAge == '<6 Months') {
      queryparams.age = 3
    } else if (stockQuantityAge == '<1 Year') {
      queryparams.age = 4
    } else if (stockQuantityAge == '<2 Years') {
      queryparams.age = 5
    } else if (stockQuantityAge == '<3 Years') {
      queryparams.age = 6
    } else if (stockQuantityAge == '<5 Years') {
      queryparams.age = 7
    } else if (stockQuantityAge == '>5 Years') {
      queryparams.age = 8
    }

    if (stockQuantityAge) {
      await download_age_stock_qua_data_dashboard(queryparams);
      // setDownloadButton(false)
    } else {
      window.alert('Please select Stock Quantity Age')
      // setDownloadButton(false)
    }
  }

  const ClickToDownloadPendingOutboundGraphData = async () => {
    setDownloadButton(true);
    let queryparams = {
      warehouse_code: warehouseData.warehouse_code,
      customer_name: getValues('customer_name') ? getValues('customer_name').customer_name : null
    };

    if (PendingOutboundDate == '24 Hr') {
      queryparams.pending_outbound_from_date = '0.8'
    } else if (PendingOutboundDate == '2 Days') {
      queryparams.pending_outbound_from_date = '1.8'
    } else if (PendingOutboundDate == '7 Days') {
      queryparams.pending_outbound_from_date = '5'
    } else if (PendingOutboundDate == '15 Days') {
      queryparams.pending_outbound_from_date = '10'
    } else if (PendingOutboundDate == '1 Month') {
      queryparams.pending_outbound_from_date = '25'
    } else if (PendingOutboundDate == '>1 Month') {
      queryparams.pending_outbound_from_date = '32'
    }

    if (PendingOutboundDate) {
      await download_pending_outbound_data_dashboard(queryparams);
      setDownloadButton(false)
    } else {
      window.alert('Please select Pending GRN From')
      setDownloadButton(false)
    }
  }

  const getWarehouseNamesList = async () => {
    let postobj = { email: sessionStorage.getItem('user_email') };
    list_warehouse_master_by_email(postobj, sessionStorage.getItem('token')).then((data) => {

      if (data.Records[0] == null) {
        console.log('errror');
      } else {
        setWarehouseDataDropdown(data.Records[0][0].warehouselist.split(","));
        sessionStorage.setItem("user_type", data.Records[0][0].user_type)
        sessionStorage.setItem('warehouseCodes', JSON.stringify(data.Records[0][0].warehouse_codes));
        setWarehouseNamesList(data.Records[0][0].warehouse_codes);
      }
    });
  }

  const complainceReportsData = async (finYrs, type, wdata) => {
    setGrnComplainceDashboardResponse([]);
    setVivoComplainceDashboardResponse([]);
    setMrComplainceDashboardResponse([]);
    setMonthsOfFinancialYrVivo([]);
    setMonthsOfFinancialYrGrn([]);
    setMonthsOfFinancialYrMr([])

    let queryparams2 = {
      warehouse_code: type === 'fromIframe' ? wdata.warehouse_code : warehouseData.warehouse_code,
      financial_year: (getValues('financial_year') && getValues('financial_year').value) ? getValues('financial_year').value : finYrs[0].value,
      customer_name: getValues('customer_name') ? getValues('customer_name').customer_name : null,
    };

    grn_complaince_dashboard_response(queryparams2).then(grnComplainceResponse => {
      if (grnComplainceResponse && grnComplainceResponse.Records && grnComplainceResponse.Records[0]) {
        setMonthsOfFinancialYrGrn(grnComplainceResponse.Records[0][0].months)
        setGrnComplainceDashboardResponse(grnComplainceResponse.Records[0])
      }
    });

    vivo_complaince_dashboard_response(queryparams2).then(vivoComplainceResponse => {
      if (vivoComplainceResponse && vivoComplainceResponse.Records && vivoComplainceResponse.Records[0]) {
        setMonthsOfFinancialYrVivo(vivoComplainceResponse.Records[0][0].months)
        setVivoComplainceDashboardResponse(vivoComplainceResponse.Records[0])
      }
    });

    mr_complaince_dashboard_response(queryparams2).then(mrComplainceResponse => {
      if (mrComplainceResponse && mrComplainceResponse.Records && mrComplainceResponse.Records[0]) {
        setMonthsOfFinancialYrMr(mrComplainceResponse.Records[0][0].months)
        setMrComplainceDashboardResponse(mrComplainceResponse.Records[0])
      }
    });
  }

  const getDashboardInboundOutboundData = async (finYrs, passedTabIndex, type, wdata) => {
    setRoundLoader(true);
    setDashboardData([])

    let queryparams = {
      warehouse_code: type === 'fromIframe' ? wdata.warehouse_code : warehouseData.warehouse_code,
      customer_name: getValues('customer_name') ? getValues('customer_name').customer_name : null,
      financial_year: (getValues('financial_year') && getValues('financial_year').value) ? getValues('financial_year').value : finYrs[0].value,
      tab_index: passedTabIndex
    };

    const dashboardResponse = await get_dashboad_data(queryparams);
    setDashboardData(dashboardResponse.Records ? dashboardResponse.Records : [])

    setValue('financial_year', getValues('financial_year') ? getValues('financial_year') : { value: finYrs[0].value })
    setRoundLoader(false);
  }

  const getInventoryDashboardData = async (finYrs, type, wdata) => {
    setSkeletonLoader(true);

    let queryparams1 = {
      warehouse_code: type === 'fromIframe' ? wdata.warehouse_code : warehouseData.warehouse_code,
      customer_name: getValues('customer_name') ? getValues('customer_name').customer_name : null,
      financial_year: (getValues('financial_year') && getValues('financial_year').value) ? getValues('financial_year').value : finYrs[0].value,
      stage: 1
    };

    const inventoryDashboardInbound = await get_inventory_inbound_data(queryparams1);
    if (inventoryDashboardInbound && inventoryDashboardInbound.Records.length > 0) {
      setSkeletonLoader(false);
      setCurrentInventoryInbound(inventoryDashboardInbound.Records)
      setExpectedInventoryDetailData([])
      setInventoryDetailData([])
      setInventoryGrnDetailDetailData([])
      setExpectedInventoryTable(false)
      setCurrentInventoryTable(false)
      setGrnStatusDetailInventoryTable(false)
    }
  }

  const getAddBtnData = async (data) => {

    const getQueryParamasDetails = () => {
      let queryparams = {
        warehouse_code: warehouseData.warehouse_code,
        financial_year: (getValues('financial_year') && getValues('financial_year').value) ? getValues('financial_year').value : FinancialYears[0].value,
        customer_name: getValues('customer_name') ? getValues('customer_name').customer_name : null
      };
      return queryparams;
    };

    if (data == 'currentInventory') {
      if (currentInventoryTable == false) {

        const QueryParamasDetails = getQueryParamasDetails()
        QueryParamasDetails.stage = 2

        const inventoryDashboardInboundDetail = await get_inventory_inbound_data(QueryParamasDetails);
        if (inventoryDashboardInboundDetail && inventoryDashboardInboundDetail.Records.length > 0) {
          setInventoryDetailData(inventoryDashboardInboundDetail.Records)
        }

      } else {
        setInventoryDetailData([])
      }
      setCurrentInventoryTable(!currentInventoryTable)
    }
    if (data == 'expectedInventory') {

      if (expectedInventoryTable == false) {

        const QueryParamasDetails = getQueryParamasDetails()
        QueryParamasDetails.stage = 4

        const expectedInventoryDashboardInboundDetail = await get_inventory_inbound_data(QueryParamasDetails);
        if (expectedInventoryDashboardInboundDetail && expectedInventoryDashboardInboundDetail.Records.length > 0) {
          setExpectedInventoryDetailData(expectedInventoryDashboardInboundDetail.Records)
        }

      } else {
        setExpectedInventoryDetailData([])
      }
      setExpectedInventoryTable(!expectedInventoryTable)
    }
  }

  const openCloseGrnStatusDetailTable = async () => {

    const getQueryParamasDetails = () => {
      let queryparams = {
        warehouse_code: warehouseData.warehouse_code,
        financial_year: (getValues('financial_year') && getValues('financial_year').value) ? getValues('financial_year').value : FinancialYears[0].value,
        customer_name: getValues('customer_name') ? getValues('customer_name').customer_name : null
      };
      return queryparams;
    };

    if (GrnStatusDetailIventoryTable == false) {

      const QueryParamasDetails = getQueryParamasDetails()
      QueryParamasDetails.stage = 3

      const inventoryGrnDetailInboundDetail = await get_inventory_inbound_data(QueryParamasDetails);

      if (inventoryGrnDetailInboundDetail && inventoryGrnDetailInboundDetail.Records.length > 0) {
        setInventoryGrnDetailDetailData(inventoryGrnDetailInboundDetail.Records)
      }

    } else {
      setInventoryGrnDetailDetailData([])
    }
    setGrnStatusDetailInventoryTable(!GrnStatusDetailIventoryTable)
  }

  const openCloseCompletedOrPendingInventory = async (pasd_status) => {

    const getQueryParamasDetails = () => {
      let queryparams = {
        warehouse_code: warehouseData.warehouse_code,
        financial_year: (getValues('financial_year') && getValues('financial_year').value) ? getValues('financial_year').value : FinancialYears[0].value,
        customer_name: getValues('customer_name') ? getValues('customer_name').customer_name : null
      };
      return queryparams;
    };

    if (pasd_status === 'COMPLETED') {
      if (CurrInventCompletedOkDamage == false) {

        const QueryParamasDetails = getQueryParamasDetails()
        QueryParamasDetails.stage = 5
        QueryParamasDetails.sap_type = pasd_status

        const inventoryGrnDetailInboundDetail = await get_inventory_inbound_data(QueryParamasDetails);

        if (inventoryGrnDetailInboundDetail && inventoryGrnDetailInboundDetail.Records.length > 0) {
          setCurInventCompletedOkDamageData(inventoryGrnDetailInboundDetail.Records)
        }

      } else {
        setCurInventCompletedOkDamageData([])
      }
      setCurrInventCompletedOkDamage(!CurrInventCompletedOkDamage)
    }
    if (pasd_status === 'PENDING') {
      if (CurrInventPendingOkDamage == false) {

        const QueryParamasDetails = getQueryParamasDetails()
        QueryParamasDetails.stage = 5
        QueryParamasDetails.sap_type = pasd_status

        const inventoryGrnDetailInboundDetail = await get_inventory_inbound_data(QueryParamasDetails);

        if (inventoryGrnDetailInboundDetail && inventoryGrnDetailInboundDetail.Records.length > 0) {
          setCurInventPendingOkDamageData(inventoryGrnDetailInboundDetail.Records)
        }

      } else {
        setCurInventPendingOkDamageData([])
      }
      setCurrInventPendingOkDamage(!CurrInventPendingOkDamage)
    }
  }

  const onSubmit = async () => {
    setConsignmentReport("Reports of Consignment");
    getDashboardInboundOutboundData(FinancialYears, 0);
    getInventoryDashboardData(FinancialYears);
    complainceReportsData(FinancialYears);
    getPendingGRNData();
  }

  const handleReset = (type, warehouseData) => {
    setConsignmentReport("Reports of Consignment");
    SetResetvalues(!resetvalues);
    reset();
    getDashboardInboundOutboundData(FinancialYears, 0, type, warehouseData);
    getInventoryDashboardData(FinancialYears, type, warehouseData);
    getPendingGRNData(type, warehouseData);
    complainceReportsData(FinancialYears, type, warehouseData);
  };

  const getWareHouseId = async (value) => {
    setValue("warehouse_name", value);
    const result = findWarehouseCodeByName(value);
    let obj = { warehouse_code: result, warehouse_name: value }
    setWarehouseData(obj)
    handleReset('fromIframe', obj);
  }

  function findWarehouseCodeByName(warehouse_name) {
    for (const warehouse of warehouseNamesList[0].warehouse_code) {
      if (warehouse.warehouse_name === warehouse_name) {
        return warehouse.warehouse_code;
      }
    }
    return null;
  }

  const PendingGrnOptions = [
    {
      value: '24 Hr'
    },
    {
      value: '2 Days'
    },
    {
      value: '7 Days'
    },
    {
      value: '15 Days'
    },
    {
      value: '1 Month'
    },
    {
      value: '>1 Month'
    }
  ]

  const PendingGrnOptions1 = {
    options: PendingGrnOptions ? PendingGrnOptions : [],
    getOptionLabel: (option) => option.value,
  };

  const AgeStockQuantityOptions = [
    {
      value: '<1 Month'
    },
    {
      value: '<3 Months'
    },
    {
      value: '<6 Months'
    },
    {
      value: '<1 Year'
    },
    {
      value: '<2 Years'
    },
    {
      value: '<3 Years'
    },
    {
      value: '<5 Years'
    },
    {
      value: '>5 Years'
    },
  ]

  const AgeStockQuantityOptions1 = {
    options: AgeStockQuantityOptions ? AgeStockQuantityOptions : [],
    getOptionLabel: (option) => option.value,
  };

  return (
    <>
      {/* {roundLoader ? <RoundLoader handleToggle={true} handleClose={true} /> : <> </>} */}

      <Box pt={2}>
        <PageTitle title={`Dashboard - ${warehouseData.warehouse_name}`} />
      </Box>

      {/* {
        window.top !== window.self && (
          <Box py={1}>
            <Paper elevation={0}>
              <Box p={2}>
                <Grid container>
                  <Grid item xs={3} spacing={2}>
                    <AutocompleteController
                      name="warehouse_name"
                      control={control}
                      Values={wareHouseNamesList}
                      required={true}
                      defaultValue={window.top !== window.self ?
                        JSON.parse('{"warehouse_code":"WHJH003","warehouse_name":"IM Section- Jamshedpur"}').warehouse_name :
                        JSON.parse(sessionStorage.getItem('warehouseData')).warehouse_name}
                      getValueChanged={(data) => {
                        getWareHouseId(data);
                      }}
                      rules={{ required: true }}
                      id="warehouse_name"
                      label="Warehouse Name"
                    />
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Box>
        )
      } */}

      <Box py={1}>
        <Paper elevation={0}>
          <Box p={3}>
            <form
              onSubmit={handleSubmit(onSubmit)}
              id="dashboard_data"
              key={resetvalues}
            >
              <Grid container spacing={2}>
                {window.top !== window.self && (
                    <Grid item xs={12} sm={3}>
                      <AutocompleteController
                        name="warehouse_name"
                        control={control}
                        Values={wareHouseNamesList}
                        required={true}
                        defaultValue={window.top !== window.self ?
                          JSON.parse('{"warehouse_code":"WHJH003","warehouse_name":"IM Section- Jamshedpur"}').warehouse_name :
                          JSON.parse(sessionStorage.getItem('warehouseData')).warehouse_name}
                        getValueChanged={(data) => {
                          getWareHouseId(data);
                        }}
                        rules={{ required: true }}
                        id="warehouse_name"
                        label="Warehouse Name"
                      />
                    </Grid>
                  )} 
                <Grid item xs={12} sm={3}>
                  <AutocompleteController
                    name="customer_name"
                    control={control}
                    Values={CustomerNames}
                    id="customer_name"
                    label="Customer Name"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AutocompleteController
                    name="financial_year"
                    control={control}
                    Values={financialYrs}
                    id="financial_year"
                    label="Financial Year"
                  />
                </Grid>

                <Grid item>
                  <Grid container>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      form="dashboard_data"
                      className={clsx(classes.subTextButton, 'mr-1')}
                      disabled={roundLoader}
                    >
                      {`Submit`}
                    </Button>
                    <Button
                      variant="outlined"
                      className={clsx(classes.subTextButton)}
                      onClick={handleReset}
                      disabled={roundLoader}
                    >
                      Clear
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Paper>
      </Box>

      <Box pt={1}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm>
            <Box pb={1}>
              <FormControl
                component="fieldset"
              >
                <RadioGroup
                  row
                  aria-label="type_of_txn"
                  name="type_of_txn"
                  value={ConsignmentReport}
                  onChange={handleInboundValue}
                >
                  <FormControlLabel
                    value="Reports of Consignment"
                    control={<Radio />}
                    label="Reports of Consignment"
                  />

                  <FormControlLabel
                    value="Vehicle (Inbound)"
                    control={<Radio />}
                    label="Vehicles (Inbound)"
                  />

                  <FormControlLabel
                    value="Receiving UMC"
                    control={<Radio />}
                    label="Receiving UMC"
                  />

                  <FormControlLabel
                    value="Reports of Indent"
                    control={<Radio />}
                    label="Reports of Indent"
                  />
                  <FormControlLabel
                    value="Vehicles (Outbound)"
                    control={<Radio />}
                    label="Vehicles (Outbound)"
                  />

                  <FormControlLabel
                    value="Issued UMC"
                    control={<Radio />}
                    label="Issued UMC"
                  />
                </RadioGroup>
              </FormControl>
            </Box>

            {ConsignmentReport === "Reports of Consignment" &&
              <>
                <Box pb={2}>
                  <h3><b>Job Data</b></h3>
                </Box>
                <Grid container
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch" spacing={2}>
                  <DashboardCard
                    heading={'Consignments Received'}
                    parameter={cardParameters}
                    value={inBoundJobsReceived}
                    className="grOne"
                  />
                  <DashboardCard
                    heading={'Consignments In Progress'}
                    parameter={cardParameters}
                    value={inBoundJobsInProgess}
                    className="grThree"
                  />
                  <DashboardCard
                    heading={'Consignments Completed'}
                    parameter={cardParameters}
                    value={inBoundJobsCompleted}
                    className="grTwo"
                  />
                  <DashboardCard
                    heading={'SAP GRN Pending'}
                    parameter={cardParameters}
                    value={inBoundSapGrnPending}
                    className="grFour"
                  />
                </Grid>
              </>
            }

            {ConsignmentReport === "Receiving UMC" &&
              <>
                <Box pb={2}>
                  <h3><b>UMC Data</b></h3>
                </Box>
                <Grid container
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch" spacing={2}>
                  <DashboardCard
                    heading={'Total UMC Count'}
                    parameter={cardParameters}
                    value={inBoundUMCsReceived}
                    className="grOne"
                  />
                  <DashboardCard
                    heading={`UMC's In Progress`}
                    parameter={cardParameters}
                    value={inBoundUMCsInProgess}
                    className="grTwo"
                  />
                  <DashboardCard
                    heading={`UMC's Completed`}
                    parameter={cardParameters}
                    value={inBoundUMCsCompleted}
                    className="grThree"
                  />
                  <DashboardCard
                    heading={`SAP Pending UMC's`}
                    parameter={cardParameters}
                    value={inBoundUMCsSapGrnPending}
                    className="grFour"
                  />
                </Grid>
              </>
            }

            {ConsignmentReport === "Vehicle (Inbound)" &&
              <>
                <Box pb={2}>
                  <h3><b>Vehicles Data</b></h3>
                </Box>
                <Grid container
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch" spacing={2}>
                  <DashboardCard
                    heading={'Vehicles Reported'}
                    parameter={cardParameters}
                    value={inboundVehicleReported}
                    className="grFour"
                  />
                  <DashboardCard
                    heading={'Unloading In Progress'}
                    parameter={cardParameters}
                    value={inboundUnloadInProgress}
                    className="grThree"
                  />
                  <DashboardCard
                    heading={'Released from Gate'}
                    parameter={cardParameters}
                    value={inboundReleaseFromGate}
                    className="grTwo"
                  />
                  <DashboardCard
                    heading={'Vehicles Diverted'}
                    parameter={cardParameters}
                    value={inboundVehiclesDiverted}
                    className="grOne"
                  />
                </Grid>
              </>
            }

            {ConsignmentReport === "Reports of Indent" &&
              <>
                <Box pb={2}>
                  <h3><b>Indent Data</b></h3>
                </Box>
                <Grid container
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch" spacing={2}>
                  <DashboardCard
                    heading={'Indent Received'}
                    parameter={cardParameters}
                    value={outBoundIndentReceived}
                    className="grTwo"
                  />
                  <DashboardCard
                    heading={'Indents In Progress'}
                    parameter={cardParameters}
                    value={outBoundIndentInProgress}
                    className="grOne"
                  />
                  <DashboardCard
                    heading={'Indents Completed'}
                    parameter={cardParameters}
                    value={outBoundIndentCompleted}
                    className="grFour"
                  />
                  <DashboardCard
                    heading={'POD Pending'}
                    parameter={cardParameters}
                    value={outBoundPODSubmitted}
                    className="grThree"
                  />
                </Grid>
              </>
            }

            {ConsignmentReport === "Vehicles (Outbound)" &&
              <>
                <Box pb={2}>
                  <h3><b>Indent Vehicle Data</b>
                  </h3>
                </Box>
                <Grid container
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch" spacing={2}>
                  <DashboardCard
                    heading={'Vehicles Reported'}
                    parameter={cardParameters}
                    value={outboundVehiclesReported}
                    className="grThree"
                  />
                  <DashboardCard
                    heading={'Loading In Progress'}
                    parameter={cardParameters}
                    value={outBoundVehiclesLoadingInProgress}
                    className="grFour"
                  />
                  <DashboardCard
                    heading={'Vehicles Released'}
                    parameter={cardParameters}
                    value={outBoundVehiclesGoodsIssuedParams}
                    className="grOne"
                  />
                </Grid>
              </>
            }

            {ConsignmentReport === "Issued UMC" &&
              <>
                <Box pb={2}>
                  <h3><b>Indent UMC Data</b>
                  </h3>
                </Box>
                <Grid container
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch" spacing={2}>
                  <DashboardCard
                    heading={'UMC to be Delivered'}
                    parameter={cardParameters}
                    value={outBoundUMCIndentReceived}
                    className="grTwo"
                  />
                  <DashboardCard
                    heading={'UMC In Progress'}
                    parameter={cardParameters}
                    value={outBoundUMCIndentInProgress}
                    className="grFour"
                  />
                  <DashboardCard
                    heading={'UMC Delivered'}
                    parameter={cardParameters}
                    value={outBoundUMCIndentCompleted}
                    className="grOne"
                  />

                  <DashboardCard
                    heading={'POD Pending'}
                    parameter={cardParameters}
                    value={outBoundUMCPodSubmitted}
                    className="grThree"
                  />
                </Grid>
              </>
            }
          </Grid>
        </Grid>
      </Box>

      <Box pt={2} pb={3}>
        {skeletonLoader ? <SkeletonLoader /> :
          <Grid container spacing={2}>
            <Grid item sm>
              <InventoryStatus getAddBtnData={getAddBtnData} currentInventoryInbound={currentInventoryInbound}
                currentInventoryTable={currentInventoryTable} expectedInventoryTable={expectedInventoryTable} />
            </Grid>
          </Grid>
        }

        <Grid container spacing={2}>
          {currentInventoryTable && <Grid item sm={12} md={6}>
            {(currentInventoryTable) &&
              <InventoryDetailTable openCloseGrnStatusDetailTable={openCloseGrnStatusDetailTable} inventoryDetailData={inventoryDetailData}
                GrnStatusDetailIventoryTable={GrnStatusDetailIventoryTable} openCloseCompletedOrPendingInventory={openCloseCompletedOrPendingInventory}
                CurrInventPendingOkDamage={CurrInventPendingOkDamage} CurrInventCompletedOkDamage={CurrInventCompletedOkDamage}
              />}
          </Grid>}

          <Grid item sm={12} md={6}>
            {(expectedInventoryTable) &&
              <ExpectedInventoryDetailTable expectedInventoryDetailData={expectedInventoryDetailData} />
            }
          </Grid>
        </Grid>

        {/* Latest Changes */}
        <Grid container spacing={2}>
          {CurrInventCompletedOkDamage && <Grid item sm={12} md={6}>
            {(CurrInventCompletedOkDamage) &&
              <OkDamageCompletedInventory CurInventCompletedOkDamageData={CurInventCompletedOkDamageData} />}
          </Grid>}

          <Grid item sm={12} md={6}>
            {(CurrInventPendingOkDamage) &&
              <OkDamagePendingInventory CurInventPendingOkDamageData={CurInventPendingOkDamageData} />
            }
          </Grid>
        </Grid>
        {/* Latest Changes ended */}

        <Grid container spacing={2}>
          {(GrnStatusDetailIventoryTable) && <Grid item sm>
            <InventoryGrnStatusDetailTable inventoryGrnDetailData={inventoryGrnDetailData} />
          </Grid>}
        </Grid>
      </Box>

      {/* ----- Age Wise Stock Status ----- */}
      <Grid container spacing={2}>
        {(ageWiseResponse && ageWiseResponse.length > 0) &&
          <Grid item xs md={warehouseData.warehouse_name.includes('Pravesh') ? 6 : 12} sm={warehouseData.warehouse_name.includes('Pravesh') ? 6 : 12}>
            <LineChart
              series={ageWiseResponse}
              title={'Age Wise Stock Status'}
              categories_X={ageWiseCategories_X}
              title_Y={'Value in Cr.'}
              title_X={''}
              color1={'#77B6EA'}
              color2={'#cf811b'}
            />
          </Grid>}

        {warehouseData.warehouse_name.includes('Pravesh') && <>
          {(ageWiseQuantityResponse && ageWiseQuantityResponse.length > 0) &&
            <Grid item xs md={6} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <AutocompleteController
                    name="stock_quantity_age"
                    control={control}
                    Values={AgeStockQuantityOptions1}
                    rules={{ required: false }}
                    id="stock_quantity_age"
                    label="Stock Quantity Age"
                    getValueChanged={(data) => {
                      setStockQuantityAge(data.value)
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={ClickToDownloadStockQuantityAgeGraphData}
                    className={clsx(classes.subTextButton)}
                    disabled={DownloadButton}
                  >
                    Download
                  </Button>
                </Grid>
              </Grid>
              <OutbondStatus
                series={ageWiseQuantityResponse}
                title={'Age Wise Stock Quantity Status'}
                categories_X={ageWiseCategories_X}
                title_Y={'No. of Units'}
                title_X={''}
              />
            </Grid>}
        </>}
      </Grid>

      {/* ----- Pending GRN Status and Outbond Status ----- */}
      <Box pt={2}>
        <Grid container spacing={4}>
          {(sapPendingChartData && sapPendingChartData.length > 0) &&
            <>
              <Grid item xs={12} sm={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <AutocompleteController
                      name="pending_grn_from"
                      control={control}
                      Values={PendingGrnOptions1}
                      rules={{ required: false }}
                      id="pending_grn_from"
                      label="Pending GRN From"
                      getValueChanged={(data) => {
                        setPendingGrnDate(data.value)
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={ClickToDownloadPendingGrnGraphData}
                      className={clsx(classes.subTextButton)}
                      disabled={DownloadButton}
                    >
                      Download
                    </Button>
                  </Grid>
                </Grid>

                <PendingStatus
                  series={sapPendingChartData}
                  title={'Pending GRN Status'}
                  categories_X={pendingGRNCategories_X}
                  categories_Y={false}
                  title_Y={'No. OF GRN'}
                  title_X={''}
                />
              </Grid>
            </>}
          {(outBoundDashboardResponse && outBoundDashboardResponse.length > 0) &&
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <AutocompleteController
                    name="pending_outbound_from"
                    control={control}
                    Values={PendingGrnOptions1}
                    rules={{ required: false }}
                    id="pending_outbound_from"
                    label="Pending Outbound From"
                    getValueChanged={(data) => {
                      setPendingOutboundDate(data.value)
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={ClickToDownloadPendingOutboundGraphData}
                    className={clsx(classes.subTextButton)}
                    disabled={DownloadButton}
                  >
                    Download
                  </Button>
                </Grid>
              </Grid>
              <OutbondStatus
                series={outBoundDashboardResponse}
                title={'Outbound Status'}
                categories_X={outbondCategories_X}
                title_Y={'No. OF MR'}
                title_X={''}
              />
            </Grid>}
          {/* <Grid item xs={4}>
          <InboundConsignmentStatus 
          mainHead = {"Physical Verification Status"}
          type = {false}
          />
        </Grid> */}
        </Grid>
      </Box>

      {/* ----- GRN, VIVO and MR Compliance ----- */}
      <Box pt={3}>
        <Grid container spacing={2}>
          {(grnComplainceDashboardResponse && grnComplainceDashboardResponse.length > 0) && <Grid item xs={4}>
            <LineChart
              title={'GRN Compliance (Within 48hr)'}
              series={grnComplainceDashboardResponse}
              categories_X={financialYrMonthsGrn}
              categories_Y={true}
              title_X={''}
              title_Y={''}
              color1={'#cf811b'}
              color2={''}
            />
          </Grid>}
          {(vivoComplainceDashboardResponse && vivoComplainceDashboardResponse.length > 0) && <Grid item xs={4}>
            <LineChart
              title={'VIVO Compliance (Within 24hr)'}
              series={vivoComplainceDashboardResponse}
              categories_X={financialYrMonthsVivo}
              categories_Y={true}
              title_X={''}
              title_Y={''}
              color1={'#6bab3e'}
              color2={''}
            />
          </Grid>}
          {(mrnComplainceDashboardResponse && mrnComplainceDashboardResponse.length > 0) && <Grid item xs={4}>
            <LineChart
              title={'MR Compliance (Within 48hr)'}
              series={mrnComplainceDashboardResponse}
              categories_X={financialYrMonthsMr}
              categories_Y={true}
              title_X={''}
              title_Y={''}
              color1={'#1564b3'}
              color2={''}
            />
          </Grid>}
        </Grid>
      </Box>
    </>
  );
}